import { render, staticRenderFns } from "./SpectrumH5.vue?vue&type=template&id=07417ded&scoped=true&"
import script from "./SpectrumH5.vue?vue&type=script&lang=js&"
export * from "./SpectrumH5.vue?vue&type=script&lang=js&"
import style0 from "./SpectrumH5.vue?vue&type=style&index=0&id=07417ded&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07417ded",
  null
  
)

export default component.exports